export const LOCAL_STORAGE_KEYS = {
  DISMISSED_UPDATES: 'dismissedUpdates',
  WIDGET_BUILDER: 'widgetBubble_',
  DRAFT_MESSAGES: 'draftMessages',
  DRAFT_SIGNATURES: 'draftSignatures',
  DRAFT_AI_SUGGESTIONS: 'draftAiSuggestions',
  DRAFT_DROPPED_ATTACHMENTS: 'draftDroppedAttachments',
  COLOR_SCHEME: 'color_scheme',
  DISMISSED_LABEL_SUGGESTIONS: 'labelSuggestionsDismissed',
  MESSAGE_REPLY_TO: 'messageReplyTo',
  CONVERSATION_TABS: 'conversationTabs',
};
